import { Grid } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OPCheckBox } from '../../../OPcomponents/OPCheckBox'
import CVCard from './CVCard'
import { useCVSettings } from './CVSettingsContext'

export const ExpertisePPTXCard: React.FC = () => {
  const { t } = useTranslation()
  const { state, handleSwitchChange } = useCVSettings()
  const { pptx_inc_knowhow, pptx_inc_showskills, pptx_inc_keyskills, pptx_inc_showroles, pptx_inc_keyroles, pptx_inc_experiencetime } = state

  return (
    <CVCard
      title={t('CVTemplates.Expertise')}
      description={t('CVTemplates.ExpertiseAndRoles')}
      isEnabled={pptx_inc_knowhow}
      toggleName='pptx_inc_knowhow'
      onToggleChange={handleSwitchChange}
    >
      <Grid item>
        <OPCheckBox
          name='pptx_inc_showskills'
          label={t('CVTemplates.ShowSkills')}
          value={pptx_inc_showskills}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='pptx_inc_keyskills'
          label={t('CVTemplates.KeySkillsOnly')}
          value={pptx_inc_keyskills}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='pptx_inc_showroles'
          label={t('CVTemplates.ShowRoles')}
          value={pptx_inc_showroles}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='pptx_inc_keyroles'
          label={t('CVTemplates.KeyRolesOnly')}
          value={pptx_inc_keyroles}
          onChangeState={handleSwitchChange}
        />
      </Grid>
      <Grid item>
        <OPCheckBox
          name='pptx_inc_experiencetime'
          label={t('CVTemplates.ShowExperienceDuration')}
          value={pptx_inc_experiencetime}
          onChangeState={handleSwitchChange}
        />
      </Grid>
    </CVCard>
  )
}
